// extracted by mini-css-extract-plugin
module.exports = {"tourNoResults":"tourNoResults__tourNoResults___1nZ-d","placeHolderShimmer":"tourNoResults__placeHolderShimmer___2Q6h0"};